module.exports = __webpack_public_path__ + "static/media/English_US_Ariana BG-18.54152fa8.png";